import { render } from "./navbarListItem.vue?vue&type=template&id=f4bde10a&scoped=true"
import script from "./navbarListItem.vue?vue&type=script&lang=js"
export * from "./navbarListItem.vue?vue&type=script&lang=js"

import "./navbarListItem.vue?vue&type=style&index=0&id=f4bde10a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-f4bde10a"

export default script